/* global jQuery */
const moment = require('moment-timezone');
angular
  .module('ordersSearch')
  .component('ordersSearch', {
    template: require('./orders-search.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function OrdersSearchController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $scope.doLogout = $rootScope.gLogout;
        $rootScope.mainmenu = 'orders';
        $rootScope.menu = 'ordersSearch';
        $scope.showOrderView = $rootScope.gShowOrderView;
        $scope.showUserView = $rootScope.gShowUserView;
        this.showEmployeeView = $rootScope.gShowEmployeeView;
        this.orderFunc = $rootScope.orderFunc;
        const APIURL = envService.read('apiUrl');
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        function handlePushMessage({ MESSAGE_TYPE, MESSAGE }) {
          let pushMessage = '세차가 취소되었습니다.';
          if (MESSAGE_TYPE === '0') {
            pushMessage = '세차가 취소되었습니다.';
          } else if (MESSAGE_TYPE === '1') {
            pushMessage = '고객님의 주문이 노쇼(no-show)로 인해 취소되었습니다. 해당 취소 사유는 결제금액이 환불되지 않습니다.';
          } else if (MESSAGE_TYPE === '2') {
            pushMessage = MESSAGE;
          }
          return pushMessage;
        }
        const initData = () => {
          this.targetOrder = undefined;
          this.orders = [];
          this.totalCount = 0;
        };
        const initParams = () => {
          this.searchParams = {
            userName: '',
            goodsType: '',
            tbUserIdEmployee: undefined,
            queryGoodsOptionAndOr: 'AND',
            jobType: 'W',
            optionName: '',
            dateStart: null,
            dateEnd: null,
          };
          this.targetEmployee = '-1';
          this.order = '';
          this.targetPage = 1;
        };
        const initialization = () => {
          initData();
          initParams();
          this.isLoading = false;
          this.orderType = -1;
          this.targetStatus = 'none';
          this.employees = [];
          this.goodsTypes = [];
          this.options = [];
        };
        function alertError(err) {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        }
        this.search = () => {
          this.isLoading = true;
          this.paging(1);
        };
        this.reset = () => {
          initData();
          initParams();
        };
        this.isCanceled = (order) => {
          if (!order || !order.STATUS) { return false; }
          const status = parseInt(order.STATUS, 10);
          if (status >= 96 && status <= 99 && status !== 97) {
            return true;
          }
          return false;
        };
        this.paging = (page) => {
          this.targetPage = page;
          let status;
          if (this.targetStatus !== 'none') {
            status = this.targetStatus;
          }
          const formatQueryDate = (value) => (value ? moment(value).format('YYYY-MM-DD') : '');
          const payload = { page: page - 1, queryUserName: this.searchParams.userName, queryGoods: this.searchParams.goodsType, queryOption: this.searchParams.optionName, queryDateStart: formatQueryDate(this.searchParams.dateStart), queryDateEnd: formatQueryDate(this.searchParams.dateEnd), queryGoodsOptionAndOr: this.searchParams.queryGoodsOptionAndOr, type: this.orderType, status, tb_user_id_employee: this.searchParams.tbUserIdEmployee || this.targetEmployee, order: this.order, timezone: moment.tz.guess(), target_date: 'none', jobType: this.searchParams.jobType };
          this.isLoading = true;
          $resource(`${APIURL}/admin/orders`).get(payload, (data) => {
            this.orders = data.orders;
            this.totalCount = data.total_count;
            this.dates = data.dates;
            this.employees = data.employees;
            this.statuses = data.statuses;
            this.isLoading = false;
          }, (err) => {
            this.isLoading = false;
            alertError(err);
          });
        };
        const reload = () => {
          this.paging(this.targetPage);
        };
        this.cancelOrder = (order, cancelPayment) => {
          const msg = $translate.instant('취소 사유를 입력해주세요.');
          const cancelComment = $window.prompt(msg);
          if (cancelComment === null || cancelComment === undefined || cancelComment.length < 1) {
            alert($translate.instant('취소 사유를 입력해주세요.'));
            return;
          }
          const pushMessage = handlePushMessage(this.cancelPayload);
          if (pushMessage < 1) {
            alert($translate.instant('메세지를 입력해주세요.'));
            return;
          }
          $resource(`${APIURL}/admin/orders/:order_no/cancel`, { order_no: order.ORDER_NO }).save({ COMMENT: cancelComment, CANCEL_PAYMENT: cancelPayment, PUSH_MESSAGE: pushMessage, PAY_5000: this.cancelPayload.PAY_5000 },
            () => {
              alert($translate.instant('취소되었습니다.'));
              order.STATUS = '98';
              order.STATUS_NAME = $translate.instant('세차취소(서버)');
              order.CANCEL_COMMENT = cancelComment;
              reload();
            }, (err) => { alertError(err); });
        };
        this.refundByCoupon = (order) => {
          const msg = $translate.instant('취소 사유를 입력해주세요.');
          const cancelComment = $window.prompt(msg);
          if (cancelComment === null || cancelComment === undefined || cancelComment.length < 1) {
            alert($translate.instant('취소 사유를 입력해주세요.'));
            return;
          }
          $resource(`${APIURL}/admin/orders/:orderNo/refund`, { orderNo: order.ORDER_NO }).save({
            CANCEL_COMMENT: cancelComment,
          }, () => {
            alert($translate.instant('취소되었습니다.'));
            order.STATUS = '98';
            order.STATUS_NAME = $translate.instant('세차취소(서버)');
            order.CANCEL_COMMENT = cancelComment;
          }, (err) => { alertError(err); });
        };
        this.minuteFromSecond = function _(second) {
          const minute = Math.round(second / 60);
          if (!minute) {
            return '-';
          }
          return minute;
        };
        this.view = (order) => {
          this.targetOrder = order;
          $resource(`${APIURL}/admin/orders/${order.ORDER_NO}`).get({}, (data) => {
            this.targetOrder = data.order;
            this.cancelPayload = { MESSAGE_TYPE: '0', PUSH_MESSAGE: '', PAY_5000: 'N' };
            jQuery('#modal-order-detail').modal('show');
          }, (err) => { alertError(err); });
        };
        this.viewAdminNote = (order) => {
          this.adminNoteEdit = '';
          this.targetOrder = order;
          if (order.ADMIN_NOTE) {
            this.adminNoteEdit = order.ADMIN_NOTE;
          }
          jQuery('#modal-admin-note').modal('show');
        };
        this.viewUser = (tbUserId) => {
          $resource(`${APIURL}/admin/users/:tb_user_id`, { tb_user_id: tbUserId }).get().$promise
            .then((data) => {
              if (data.user.NAME === undefined) {
                this.user = { NAME: $translate.instant('탈퇴한 회원입니다.') };
              } else {
                this.user = data.user;
              }
              this.isUserOnPayOnSiteBlacklist = data.isUserOnPayOnSiteBlacklist;
              jQuery('#modal-point').removeClass('fade');
              jQuery('#modal-point').modal('hide');
              jQuery('#modal-view-user').modal('show');
            })
            .catch((err) => { alertError(err); });
        };
        this.viewCancelReasons = (orderNo) => {
          this.reasons = [];
          $resource(`${APIURL}/admin/reasons/reserve/cancel/${orderNo}`).get({}).$promise
            .then((data) => {
              this.reasons = data.reasons;
              jQuery('#modal-cancel-reasons').modal('show');
            })
            .catch((err) => { alertError(err); });
        };
        this.addPoint = () => {
          this.newpoint = { PRICE: 50000 };
          jQuery('#modal-view-user').removeClass('fade');
          jQuery('#modal-view-user').modal('hide');
          jQuery('#modal-point').modal('show');
        };
        this.addPointSubmit = () => {
          if (this.newpoint.PRICE === undefined) {
            alert($translate.instant('포인트를 입력해주세요.'));
            return;
          }
          if (isNaN(parseInt(this.newpoint.PRICE, 10))) {
            alert($translate.instant('포인트를 입력해주세요.'));
            return;
          }
          $resource(`${APIURL}/admin/users/${this.user.ID}/mileage/${this.newpoint.PRICE}`).save(this.newpoint,
            () => {
              alert($translate.instant('포인트가 적립되었습니다.', { price: this.newpoint.PRICE }));
              this.user.MILEAGE = parseInt(this.user.MILEAGE, 10) + parseInt(this.newpoint.PRICE, 10);
              reload();
              jQuery('#modal-point').modal('hide');
              this.viewUser(this.user.ID);
            }, (err) => { alertError(err); });
        };
        this.moveToWashHistory = (user) => {
          jQuery('#modal-view-user').removeClass('fade');
          jQuery('#modal-view-user').modal('hide');
          $location.path(`/member/${user.ID}/wash/history`);
        };
        this.registBlacklist = (user) => {
          const comment = $window.prompt($translate.instant('블랙리스트 등록 사유를 입력해주세요.'));
          if (!comment) {
            return;
          }
          if (comment.length < 1) {
            alert($translate.instant('블랙리스트 등록 사유를 입력해주세요.'));
            return;
          }
          $resource(`${APIURL}/admin/user/blacklist/payonsite`).save({ TB_USER_ID: user.ID, COMMENT: comment }).$promise
            .then(() => {
              alert($translate.instant('등록되었습니다.'));
              jQuery('#modal-view-user').modal('hide');
            })
            .catch((err) => { alertError(err); });
        };
        this.unregistBlacklist = (user) => {
          $resource(`${envService.read('apiUrl')}/admin/user/blacklist/payonsite/${user.ID}`).delete().$promise
            .then(() => {
              alert($translate.instant('해제되었습니다.'));
              jQuery('#modal-view-user').modal('hide');
            })
            .catch((err) => { alertError(err); });
        };
        this.submitAdminNote = () => {
          $resource(`${APIURL}/admin/orders/${this.targetOrder.ORDER_NO}/note`).save({ ADMIN_NOTE: this.adminNoteEdit }).$promise
            .then(() => {
              jQuery('#modal-admin-note').modal('hide');
              this.targetOrder.ADMIN_NOTE = this.adminNoteEdit;
            })
            .catch((err) => { alertError(err); });
        };
        this.edit = (order) => {
          jQuery('#modal-order-detail').removeClass('fade');
          jQuery('#modal-order-detail').modal('hide');
          $location.path(`/orders/all/${order.ORDER_NO}`);
        };
        this.editGoodsAndOption = (order) => {
          jQuery('#modal-order-detail').removeClass('fade');
          jQuery('#modal-order-detail').modal('hide');
          $location.path(`/modify/orders/${order.ORDER_NO}/goodsAndOptions`);
        };
        this.orderbyname = () => {
          if (this.order === 'USER_ASC') {
            this.order = 'USER_DESC';
          } else {
            this.order = 'USER_ASC';
          }
          reload();
        };
        this.orderbydate = () => {
          if (this.order === 'ORDER_START_DATE_ASC') {
            this.order = 'ORDER_START_DATE_DESC';
          } else {
            this.order = 'ORDER_START_DATE_ASC';
          }
          reload();
        };
        $resource(`${APIURL}/admin/goods/types`).get().$promise
          .then((data) => {
            this.goodsTypes = data.goodsTypes;
          }).catch((err) => { alertError(err); });
        $resource(`${APIURL}/admin/goods/options/names`).get().$promise
          .then((data) => {
            this.options = data.options;
          })
          .catch((err) => { alertError(err); });
        $resource(`${APIURL}/admin/employees`).get({ count: 10000, include_unregister: false }).$promise
          .then((data) => {
            this.employees = data.users;
          })
          .catch((err) => { alertError(err); });
        initialization();
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/orders-search/orders-search.component.js